/**
 * Replace attribute
 * @param {Array<HTMLElement>} targets
 * @param {String} name
 * @param {String} values
 */
const attributeReplace = (targets, name, values) => {
  for (const target of targets) {
    target.setAttribute(name, values);
  };
};

export default attributeReplace;
